import React, { useState } from "react";
import { Grid, Typography, TextField, MenuItem } from "@mui/material";
import InputField from "../forms/input/TextInput/InputField";
import { PiUploadSimpleThin } from "react-icons/pi";
import { API } from "../../pages/backend";
import FormButton from "../ui/button/FormButton";
import axios from "axios";
import { useSelector } from "react-redux";
import data from "../dropDown";
import { toast } from "react-toastify";
import Spinner from "../ui/Spinner";

const PaymentDispute = ({ type }) => {
  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state.user.data.token);
  // const details = useSelector(
  //     (state) => state.transactionDetails.data.transactionDetails
  //   );
  //   console.log(details)
  const { modeOfPayment } = data;
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false)

  const [state, setState] = useState({
    email: "",
    bill_no: "",
    examType: "",
    modeOfPayment: "",
    imageUrl: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value.value(),
    }));
  };

  const upload = (e) => {
    // setImage(e.target.files[0]);
    const selectedImage = e.target.files[0]
    setImage(selectedImage)
    console.log(image);

    // setPreview(URL.createObjectURL(e.target.files[0]));
    const previewImage = URL.createObjectURL(selectedImage)
    setPreview(previewImage)

  };

  const  uploadImage = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("imageUrl", image);
    // const imageUrl = image;
   setLoading(true)
    try {
      const res = await axios.post(
        `${API}/disputes/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res?.data?.status === "success"){
        const imageRes = res.data.data.url
      


        // log dispute

        const data = {
          billNumber: state.bill_no,
          imageUrl: imageRes,
          modeOfPayment:state.modeOfPayment,
          email:  user?.email,
          examType: type,
         }
         
          try {
            const res = await axios.post(
              `${API}/disputes/create`,
              data,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
            if (res?.data.status === "success"){
              const response = res?.data.data 
              toast.success( response.message  || "Uploaded Successful")
              setLoading(false)
            }
          } catch (error) {
            setLoading(false)
            console.log(error)
          } 
      }

    }  catch (error) {
      console.log(error)
    } 
  };

  


  const submitDisputeDetails = async () => {};

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          padding: "50px 30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography align="center">
          If you have made payment and you're still unable to generate your
          receipt or check the status of your payment, you can log a paymnet
          dispute below. Kindly fill in the following details:
        </Typography>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 0px",
            gap: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputField
                name="email"
                label="Email"
                type="Email"
                placeholder="Enter Email"
                value={user?.email}
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              <InputField
                value={state.bill_no}
                onChange={handleFormChange}
                name="bill_no"
                label="Bill Number"
                type="text"
                placeholder="Enter Bill Number"
                // value={user?.schoolType}
                style={{ height: "100%" }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputField
                name="exam_type"
                label="Exam Type"
                type="ExamType"
                placeholder="What Exam did you pay for?"
                value={type}
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                value={state.modeOfPayment}
                onChange={(e) => {
                  setState((prevState) => ({
                    ...prevState,
                    modeOfPayment: e.target.value,
                  }));
                }}
                name="modeofpayment"
                label="Mode of Payment"
                type="Email"
                placeholder="How did you pay?"
                //   value={user?.schoolCode}
                style={{ height: "100%", width: "100%", marginTop: "2.5rem" }}
              >
                {modeOfPayment.map((payment) => (
                  <MenuItem
                    key={payment.paymentType}
                    value={payment.paymentType}
                  >
                    {" "}
                    {payment.paymentType}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <div
            style={{
              overflow: "hidden",
              width: "100%",
              border: "1px solid #9b9494",
              height: "400px",
              borderRadius: "5px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <input
                style={{ display: "none" }}
                type="file"
                id="videoUpload"
                onChange={upload}
              />

              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  height: "200px",
                  padding: "10px 10px",
                }}
                htmlFor="videoUpload"
              >
                <div style={{ height: "300px", width: "300px", size: "50px" }}>
                  <img
                    style={{
                      height: "200px",
                      width: "300px",
                      borderRadius: "4px",
                    }}
                    src={preview}
                    alt=""
                  />
                </div>
                <div>
                  <PiUploadSimpleThin size={"50px"} />
                </div>
                <div>
                  {" "}
                  <Typography flexWrap={"wrap"}>
                    {image?.name ? image?.name : "Upload Image"}
                  </Typography>
                </div>
              </label>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormButton
              align="center"
              width="medium"
              label= {loading ? <Spinner width="5%"/> :"Log Dispute"}
              onClick={uploadImage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDispute;
